import { workflowsSettingsPaths } from "@circle-react/helpers/urlHelpers";
import { useLocation } from "@tanstack/react-router";

const WORKFLOW_EDITOR_ROUTES = [
  workflowsSettingsPaths.new(),
  workflowsSettingsPaths.edit({ workflowId: "" }),
  workflowsSettingsPaths.view({ workflowId: "" }),
];

const BOT_BUILDER_EDITOR_ROUTE = "/settings/ai-agents/edit/";

export const useSettingsHeader = () => {
  const pathname = useLocation({ select: location => location.pathname });

  const isSettingsRoute = pathname.startsWith("/settings");

  const isWorkflowsEditorRoute = WORKFLOW_EDITOR_ROUTES.some(route =>
    pathname.startsWith(route),
  );

  const isBotBuilderEditorRoute = pathname.startsWith(BOT_BUILDER_EDITOR_ROUTE);

  return {
    isSettingsRoute,
    isReactFlowWorkflowsRoute: isWorkflowsEditorRoute,
    isBotBuilderEditorRoute,
  };
};
